module.exports = __webpack_public_path__ + "media/chen.6c595b59.mp3";